const SELECTORS = {
  button: "[data-gcvp-variant-id]",
};

class GiftCardVariantPicker extends HTMLElement {
  connectedCallback() {
    try {
      this.init();
    } catch (error) {
      console.error("[GiftCardVariantPicker:init]", error);
    }
  }

  init() {
    this.#bindElements();
    this.#bindEvents();
  }

  #bindElements() {
    this.buttons = Array.from(this.querySelectorAll(SELECTORS.button));
  }

  #bindEvents() {
    this.buttons.forEach((button) => {
      button.addEventListener("click", this.#onSelect.bind(this, button));
    });
  }

  #onSelect(button) {
    const variantId = Number.parseInt(button.dataset.gcvpVariantId, 10);
    if (!Number.isInteger(variantId) || variantId <= 0) {
      console.error(
        "[GiftCardVariantPicker] Invalid variant ID:",
        button.dataset.gcvpVariantId,
      );
      return;
    }

    let price = "";
    const rawPrice = button.dataset.gcvpVariantPrice;
    if (rawPrice) {
      try {
        price = JSON.parse(rawPrice);
      } catch (error) {
        console.error("[GiftCardVariantPicker] Invalid price JSON:", rawPrice);
      }
    }

    this.buttons.forEach((b) => {
      const isActive = b === button;
      b.classList.toggle("is-active", isActive);
      b.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    document.dispatchEvent(
      new CustomEvent("variant:change", {
        detail: { variantId, isDigital: true, price, comparePrice: null },
      }),
    );
  }
}

if (!customElements.get("gift-card-variant-picker")) {
  customElements.define("gift-card-variant-picker", GiftCardVariantPicker);
}
